<script setup>
const version = __APP_VERSION__;
const year = new Date().getFullYear();
</script>

<template>
    <footer class="text-center text-xs text-gray-400 py-4">
        AlloSlot v{{ version }} &nbsp;&middot;&nbsp; &copy; {{ year }} Allo Logistics AS
    </footer>
</template>
